export const enum DataSourcesActionType {
  ADD_DATA_SOURCE_STARTED = 'ADD_DATA_SOURCE_STARTED',
  ADD_DATA_SOURCE_FINISHED = 'ADD_DATA_SOURCE_FINISHED',

  ADD_DATA_SOURCE_ATTEMPT = 'ADD_DATA_SOURCE_ATTEMPT',
  ADD_DATA_SOURCE_SUCCESS = 'ADD_DATA_SOURCE_SUCCESS',
  ADD_DATA_SOURCE_FAILURE = 'ADD_DATA_SOURCE_FAILURE',

  REFRESH_DATA_SOURCES_STARTED = 'REFRESH_DATA_SOURCES_STARTED',
  REFRESH_DATA_SOURCES_FINISHED = 'REFRESH_DATA_SOURCES_FINISHED',

  REFRESH_DATA_SOURCE_TABLES_STARTED = 'REFRESH_DATA_SOURCE_TABLES_STARTED',
  REFRESH_DATA_SOURCE_TABLES_FINISHED = 'REFRESH_DATA_SOURCE_TABLES_FINISHED',

  REFRESH_DATA_SOURCE_METADATA_ATTEMPT = 'REFRESH_DATA_SOURCE_METADATA_ATTEMPT',
  REFRESH_DATA_SOURCE_METADATA_SUCCESS = 'REFRESH_DATA_SOURCE_METADATA_SUCCESS',
  REFRESH_DATA_SOURCE_METADATA_FAILURE = 'REFRESH_DATA_SOURCE_METADATA_FAILURE',

  REFRESH_DATA_SOURCE_TABLE_METADATA_ATTEMPT = 'REFRESH_DATA_SOURCE_TABLE_METADATA_ATTEMPT',
  REFRESH_DATA_SOURCE_TABLE_METADATA_SUCCESS = 'REFRESH_DATA_SOURCE_TABLE_METADATA_SUCCESS',
  REFRESH_DATA_SOURCE_TABLE_METADATA_FAILURE = 'REFRESH_DATA_SOURCE_TABLE_METADATA_FAILURE',

  REQUEST_DATA_SOURCE_INFO_ATTEMPT = 'REQUEST_DATA_SOURCE_INFO_ATTEMPT',
  REQUEST_DATA_SOURCE_INFO_SUCCESS = 'REQUEST_DATA_SOURCE_INFO_SUCCESS',
  REQUEST_DATA_SOURCE_INFO_FAILURE = 'REQUEST_DATA_SOURCE_INFO_FAILURE',

  REQUEST_DATA_SOURCE_TYPE_DESCRIPTION_ATTEMPT = 'REQUEST_DATA_SOURCE_TYPE_DESCRIPTION_ATTEMPT',
  REQUEST_DATA_SOURCE_TYPE_DESCRIPTION_SUCCESS = 'REQUEST_DATA_SOURCE_TYPE_DESCRIPTION_SUCCESS',
  REQUEST_DATA_SOURCE_TYPE_DESCRIPTION_FAILURE = 'REQUEST_DATA_SOURCE_TYPE_DESCRIPTION_FAILURE',

  REQUEST_DATA_SOURCE_LIST_INFO_ATTEMPT = 'REQUEST_DATA_SOURCE_LIST_INFO_ATTEMPT',
  REQUEST_DATA_SOURCE_LIST_INFO_SUCCESS = 'REQUEST_DATA_SOURCE_LIST_INFO_SUCCESS',
  REQUEST_DATA_SOURCE_LIST_INFO_FAILURE = 'REQUEST_DATA_SOURCE_LIST_INFO_FAILURE',

  REQUEST_DATA_SOURCE_OPTIONS_ATTEMPT = 'REQUEST_DATA_SOURCE_OPTIONS_ATTEMPT',
  REQUEST_DATA_SOURCE_OPTIONS_SUCCESS = 'REQUEST_DATA_SOURCE_OPTIONS_SUCCESS',
  REQUEST_DATA_SOURCE_OPTIONS_FAILURE = 'REQUEST_DATA_SOURCE_OPTIONS_FAILURE',

  REQUEST_DATA_SOURCE_TABLE_METADATA_ATTEMPT = 'REQUEST_DATA_SOURCE_TABLE_METADATA_ATTEMPT',
  REQUEST_DATA_SOURCE_TABLE_METADATA_SUCCESS = 'REQUEST_DATA_SOURCE_TABLE_METADATA_SUCCESS',
  REQUEST_DATA_SOURCE_TABLE_METADATA_FAILURE = 'REQUEST_DATA_SOURCE_TABLE_METADATA_FAILURE',

  REQUEST_DATA_SOURCE_TABLES_ATTEMPT = 'REQUEST_DATA_SOURCE_TABLES_ATTEMPT',
  REQUEST_DATA_SOURCE_TABLES_SUCCESS = 'REQUEST_DATA_SOURCE_TABLES_SUCCESS',
  REQUEST_DATA_SOURCE_TABLES_FAILURE = 'REQUEST_DATA_SOURCE_TABLES_FAILURE',

  REQUEST_DATA_SOURCE_TABLE_COLUMNS_ATTEMPT = 'REQUEST_DATA_SOURCE_TABLE_COLUMNS_ATTEMPT',
  REQUEST_DATA_SOURCE_TABLE_COLUMNS_SUCCESS = 'REQUEST_DATA_SOURCE_TABLE_COLUMNS_SUCCESS',
  REQUEST_DATA_SOURCE_TABLE_COLUMNS_FAILURE = 'REQUEST_DATA_SOURCE_TABLE_COLUMNS_FAILURE',

  REQUEST_VIRTUAL_GRAPHS_ATTEMPT = 'REQUEST_VIRTUAL_GRAPHS_ATTEMPT',
  REQUEST_VIRTUAL_GRAPHS_SUCCESS = 'REQUEST_VIRTUAL_GRAPHS_SUCCESS',
  REQUEST_VIRTUAL_GRAPHS_FAILURE = 'REQUEST_VIRTUAL_GRAPHS_FAILURE',

  NO_SUGGESTIONS_FOUND_WARNING = 'NO_SUGGESTIONS_FOUND_WARNING',
  REQUEST_SUGGESTIONS_ATTEMPT = 'REQUEST_SUGGESTIONS_ATTEMPT',
  REQUEST_SUGGESTIONS_SUCCESS = 'REQUEST_SUGGESTIONS_SUCCESS',
  REQUEST_SUGGESTIONS_FAILURE = 'REQUEST_SUGGESTIONS_FAILURE',

  UPDATE_DATA_SOURCE_ATTEMPT = 'UPDATE_DATA_SOURCE_ATTEMPT',
  UPDATE_DATA_SOURCE_SUCCESS = 'UPDATE_DATA_SOURCE_SUCCESS',
  UPDATE_DATA_SOURCE_FAILURE = 'UPDATE_DATA_SOURCE_FAILURE',
}
